import { ReactNode } from "react";
import { SxProps, Box } from "@mui/material";
import { FOOTER_HEIGHT, containerStyle } from "../consts";

export type FooterProps = {
    id?: string;
    sx?: SxProps;
};

type Props = { children: ReactNode } & FooterProps;

const Footer = ({ children, id, sx }: Props) => {
    return (
        <Box
            id={id || "pageFooter"}
            sx={{
                height: FOOTER_HEIGHT,
                backgroundColor: "#fff",
                boxShadow: "0px -4px 12px 0px rgba(0, 0, 0, 0.05)",
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                px: containerStyle.flow5.px,
                zIndex: 2,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
};

export default Footer;
